import * as React from "react";

function SvgPrimeMover(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill } = props;
  return (
    <svg width={13} height={13} viewBox="0 0 13 13" fill="none" {...props}>
      <g clipPath="url(#clip-prime-mover)">
        <path
          d="M4.66344 2.4375H3.10892H2.15226H0.255967C0.114789 2.4375 0 2.55203 0 2.6936V8.81745C0 8.95902 0.114789 9.07354 0.255967 9.07354H0.327597C0.469035 9.07354 0.580964 8.95798 0.606054 8.81901C0.726173 8.14951 1.31169 7.64148 2.01537 7.64148C2.71905 7.64148 3.30457 8.14938 3.42456 8.81901C3.44952 8.95798 3.5617 9.07354 3.70314 9.07354H4.6637H5.2617H7.51705C7.65848 9.07354 7.77301 8.95902 7.77301 8.81745V2.6936C7.77301 2.55203 7.65848 2.43763 7.51705 2.43763H5.26144H4.66344V2.4375Z"
          fill={fill ?? "black"}
        />
        <path
          d="M12.7439 5.98295H11.4832C11.3416 5.98295 11.2271 5.86842 11.2271 5.72698V4.01152C11.2271 3.8706 11.1125 3.75555 10.9711 3.75555H8.39272C8.25115 3.75555 8.13675 3.8706 8.13675 4.01152V8.81744C8.13675 8.95901 8.23841 9.07354 8.36399 9.07354C8.48944 9.07354 8.58876 8.95797 8.61371 8.819C8.7337 8.14951 9.3187 7.64147 10.0226 7.64147C10.7265 7.64147 11.312 8.14938 11.4322 8.819C11.4572 8.95797 11.5692 9.07354 11.7108 9.07354H12.744C12.8855 9.07354 13 8.95901 13 8.81744V6.23905C12.9999 6.09748 12.8853 5.98295 12.7439 5.98295ZM10.0473 5.60453H9.34717C9.2056 5.60453 9.09107 5.48948 9.09107 5.34856V4.648C9.09107 4.50656 9.2056 4.39203 9.34717 4.39203H10.0473C10.1889 4.39203 10.3034 4.50656 10.3034 4.648V5.34856C10.3034 5.48948 10.1889 5.60453 10.0473 5.60453Z"
          fill={fill ?? "black"}
        />
        <path
          d="M10.0306 7.96751C9.38018 7.96751 8.85239 8.49505 8.85239 9.14556C8.85265 9.79608 9.38031 10.3236 10.0306 10.3236C10.6811 10.3236 11.2086 9.79608 11.2086 9.14556C11.2086 8.49505 10.6811 7.96751 10.0306 7.96751Z"
          fill={fill ?? "black"}
        />
        <path
          d="M2.01524 7.96751C1.36472 7.96751 0.837189 8.49505 0.837189 9.14556C0.837189 9.79608 1.36472 10.3236 2.01524 10.3236C2.66601 10.3236 3.19303 9.79608 3.19303 9.14556C3.19303 8.49505 2.66601 7.96751 2.01524 7.96751Z"
          fill={fill ?? "black"}
        />
      </g>
      <defs>
        <clipPath id="clip-prime-mover">
          <rect width={13} height={13} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgPrimeMover;
